module.exports = __webpack_public_path__ + "static/img/logo-3.956daf4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/svg-img/logo-3.svg
// module id = 1392
// module chunks = 4